import { useState } from "react";
import {
  SignupErrors,
  SignupFormData,
  SignupFormProps,
} from "@components/signup/signup-form/signup-form-types";

interface UseSignupForm extends SignupFormProps {
  /** Function to set whether the password is valid */
  setIsPasswordValid: (isValid: boolean) => void;

  /** Function to validate the signup form fields */
  validateForm: () => boolean;
}

export function useSignupForm(): UseSignupForm {
  const [form, setForm] = useState<SignupFormData>({
    firstName: "",
    lastName: "",
    password: "",
  });

  const [errors, setErrors] = useState<SignupErrors>({
    isFirstNameError: false,
    isLastNameError: false,
    isPasswordError: false,
  });

  const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false);

  /** Validates the form fields */
  function validateForm(): boolean {
    let isValid = true;

    if (form.firstName.trim() === "") {
      isValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, isFirstNameError: true }));
    }

    if (form.lastName.trim() === "") {
      isValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, isLastNameError: true }));
    }

    if (!isPasswordValid) {
      isValid = false;
      setErrors((prevErrors) => ({ ...prevErrors, isPasswordError: true }));
    }

    return isValid;
  }

  return {
    form,
    setForm,
    errors,
    setErrors,
    setIsPasswordValid,
    validateForm,
  };
}
